var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-mask" }, [
    _c("div", { staticClass: "modal-wrapper" }, [
      _c("div", { staticClass: "modal_size md_size" }, [
        _c(
          "a",
          {
            staticClass: "ui_close",
            attrs: { href: "javascript:", type: "button" },
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          },
          [_c("span", { staticClass: "sr_only" })]
        ),
        _vm._v(" "),
        _c("dl", { staticClass: "modal_content" }, [
          _c("dt", { staticClass: "ellipsis" }, [
            _c("i", [_vm._v(_vm._s(_vm.flowList.QNA_STATUS_NM))])
          ]),
          _vm._v(" "),
          _c("dd", [
            _c("table", { staticClass: "create_table btmLine mt-20" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("tbody", [
                _c("tr", [
                  _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.SURVEY.FROM")))]),
                  _vm._v(" "),
                  _c("td", [
                    _c("em", { staticClass: "space_data" }, [
                      _vm._v(_vm._s(_vm.flowList.ANSWERER_NM))
                    ]),
                    _vm._v(" "),
                    _c("em", { staticClass: "space_data" }, [
                      _vm._v(_vm._s(_vm.flowList.TEAM_NM))
                    ]),
                    _vm._v(" "),
                    _c("em", { staticClass: "space_data" }, [
                      _vm._v(_vm._s(_vm.flowList.DEPT_LEVEL_NM))
                    ]),
                    _vm._v(" "),
                    _c("em", { staticClass: "space_data" }, [
                      _vm._v(_vm._s(_vm.flowList.ANSWERER_DEPT_NM))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [
                    _vm._v(_vm._s(_vm.$t("TITLE.POPUP.MESSAGE.DETAIL")))
                  ]),
                  _vm._v(" "),
                  _c("td", {
                    domProps: {
                      innerHTML: _vm._s(_vm.getMessage(_vm.flowList.MESSAGE))
                    }
                  })
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "154px" } }),
      _vm._v(" "),
      _c("col", { staticClass: "*" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-46fca9fa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46fca9fa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/faq/popup/commentPopup.vue
// module id = twQI
// module chunks = 0